const FooterPortal = () => (
    <footer className="text-center p-3 border-top mt-auto bg-light text-light-secondary">
      {/* <small className="pt-4">SG Consulting Group © 2025</small> */}
    </footer>
  );
  
  export default FooterPortal;
  